import { createStore } from 'vuex'
import { GetData } from '@/service'
import { setLocale, i18n } from '@/i18n'

export const store = createStore({
  state: {
    user: {},
    shipTos: [],
    applications: [],
    navigation: [],
    revalidationStatus: ''
  },
  mutations: {
    setUser(state, value) {
      state.user = value
    },
    setShipTos(state, value) {
      state.shipTos = value
    },
    setApplications(state, value) {
      state.applications = value
    },
    setNavigation(state, value) {
      state.navigation = value
    },
    setRevalidationStatus(state, value) {
      if (value !== null && value !== '' && value.length > 0) {
        state.revalidationStatus = 'RequiresRevalidation'
      }
    }
  },
  actions: {
    async getUser({ commit }) {
      const res = await GetData('/api/v1/user/info');
      if (res.status === 200) {
        commit('setUser', res.data)
        if (i18n.global.locale.value !== res.data.cultureCode) {
          await setLocale(res.data.cultureCode)
        }
      }
    },
    async getShipTos({ commit }) {
      const res = await GetData('/api/v1/user/shiptos');
      if (res.status === 200) {
        if (res.data.length === 0) {
          const prospectRes = await GetData('/api/v1/user/prospect');
          //go to order app if user does not have shipto and the user is prospect user
          if (prospectRes.status === 200 && prospectRes.data) window.location.href = window.__env.orderUrl
        }
        else {
          commit('setShipTos', res.data);
        }
      }
    },
    async getApplications({ commit }) {
      const res = await GetData('/api/v1/user/applications');
      if (res.status === 200) commit('setApplications', res.data)
    },
    async getRevalidationStatus({ commit }) {
      const res = await GetData('/api/v1/user/revalidationStatus');
      if (res.status === 200) commit('setRevalidationStatus', res.data)
    }
  }
})


